import { render, staticRenderFns } from "./NoPermissions.vue?vue&type=template&id=6442a8ef&"
import script from "./NoPermissions.vue?vue&type=script&lang=js&"
export * from "./NoPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports